import { z } from "zod";
import { PurchaseOrderStatusKeys } from "../types/connection";

const countField = z.number().int().nonnegative();

export const OrderStatusCountsSchema = z.object(
  Object.fromEntries(PurchaseOrderStatusKeys.map((status) => [status, countField])) as Record<
    (typeof PurchaseOrderStatusKeys)[number],
    typeof countField
  >
);

export type OrderStatusCountsData = z.infer<typeof OrderStatusCountsSchema>;
